module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAGjCAYAAAAGgcTbAAAAYElEQVRIie3PQQqAIBCFYaeLdNJO1rlCInUSLCtHWgTt/ll9jO+hyuJXdXkGd8yFlLQghFiwnaibENvNLZPasM2Yem117jJ182YZ5+n5HdE8/aMXfGsBAAAAAAAAAPgDO8U1S177v6pOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/tatb1-3.png
// module id = 756
// module chunks = 0